import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { LoginComponent } from 'src/components/auth/login/login.component'
import { BankingInfoComponent } from 'src/components/banking-info/banking-info.component'
import { DashboardComponent } from 'src/components/dashboard/dashboard.component'
import { ExecutionLogsComponent } from 'src/components/execution-logs/execution-logs.component'
import { ExpenseReportComponent } from 'src/components/expense-report/expense-report.component'
import { GlobalConstants } from 'src/constants/global-constants'
import { AuthGuard } from 'src/guards/auth.guard'
import { RouteGuard } from 'src/guards/route.guard'
import {ExpensesComponent} from "../components/expenses/expenses.component";

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    canActivate: [RouteGuard]
  },
  {
    path: GlobalConstants.ROUTING.LOGIN,
    component: LoginComponent,
    canActivate: [RouteGuard]
  },
  {
    path: GlobalConstants.ROUTING.DASHBOARD,
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: GlobalConstants.ROUTING.EXECUTION_LOGS,
    component: ExecutionLogsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: GlobalConstants.ROUTING.BANKING_INFO,
    component: BankingInfoComponent,
    canActivate: [AuthGuard]
  },
  {
    path: `${GlobalConstants.ROUTING.EXPENSE_REPORT}/:batchId`,
    component: ExpenseReportComponent,
    canActivate: [AuthGuard]
  },
  {
    path: `${GlobalConstants.ROUTING.EXPENSE_REPORT}`,
    component: ExpenseReportComponent,
    canActivate: [AuthGuard]
  },
  {
    path: `${GlobalConstants.ROUTING.EXPENSES}`,
    component: ExpensesComponent,
    canActivate: [AuthGuard]
  }
]
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
